/* Presentation only: native wish-list / wishlist-view own the saved items. */
(function () {
  'use strict';
  if (window.lcWishlistFeedbackReady) return;
  window.lcWishlistFeedbackReady = true;
  var source = document.getElementById('lc-wishlist-config');
  if (!source) return;
  var config;
  try { config = JSON.parse(source.textContent); } catch (error) { return; }
  if (!config.url || !config.label) return;

  var toast;
  var message;
  var timer;
  function hide() {
    window.clearTimeout(timer);
    if (toast) toast.hidden = true;
  }
  function scheduleHide() {
    window.clearTimeout(timer);
    if (toast && !toast.contains(document.activeElement) && !toast.matches(':hover')) {
      timer = window.setTimeout(hide, 8000);
    }
  }
  function showMessage(text, error) {
    if (!document.body) return;
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'lc-wishlist-feedback';
      toast.hidden = true;
      message = document.createElement('span');
      message.className = 'lc-wishlist-feedback__message';
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
      var link = document.createElement('a');
      link.className = 'lc-wishlist-feedback__link';
      link.href = config.url;
      link.textContent = config.label;
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'lc-wishlist-feedback__close';
      close.setAttribute('aria-label', config.close);
      close.textContent = '×';
      close.addEventListener('click', hide);
      toast.append(message, link, close);
      toast.addEventListener('mouseenter', function () { window.clearTimeout(timer); });
      toast.addEventListener('focusin', function () { window.clearTimeout(timer); });
      toast.addEventListener('mouseleave', scheduleHide);
      toast.addEventListener('focusout', function () { window.setTimeout(scheduleHide, 0); });
      document.body.appendChild(toast);
    }
    message.textContent = '';
    toast.hidden = false;
    message.setAttribute('role', error ? 'alert' : 'status');
    message.setAttribute('aria-live', error ? 'assertive' : 'polite');
    window.requestAnimationFrame(function () { message.textContent = text; });
    scheduleHide();
  }
  document.addEventListener('add:wishlist-item', function () {
    showMessage(config.added, false);
  });
  document.addEventListener('remove:wishlist-item', function () {
    hide();
  });
  document.addEventListener('lc:wishlist-storage-error', function () {
    showMessage(config.storage_error, true);
  });
  if (window.lcWishlistStorageError) showMessage(config.storage_error, true);
})();
